module.exports = __webpack_public_path__ + "lazerProduct.png?adb4c36de793d300c8a2e6959319fada";